var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraFlip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 19.5H4.875C4.47718 19.5 4.09564 19.342 3.81434 19.0607C3.53304 18.7794 3.375 18.3978 3.375 18V7.5C3.375 7.10218 3.53304 6.72064 3.81434 6.43934C4.09564 6.15804 4.47718 6 4.875 6H7.87445L9.37445 3.75H15.3745L16.8745 6H19.875C20.2728 6 20.6544 6.15804 20.9357 6.43934C21.217 6.72064 21.375 7.10218 21.375 7.5V18C21.375 18.3978 21.217 18.7794 20.9357 19.0607C20.6544 19.342 20.2728 19.5 19.875 19.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6323 11.4231H16.8823V9.1731",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4585 9.83319C9.84154 9.45014 10.2963 9.1463 10.7967 8.939C11.2972 8.7317 11.8336 8.625 12.3753 8.625C12.917 8.625 13.4534 8.7317 13.9539 8.939C14.4543 9.1463 14.9091 9.45014 15.2921 9.83319L16.8831 11.4242",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1177 14.0769H7.86768V16.3269",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2923 15.6679C14.9093 16.0509 14.4545 16.3548 13.9541 16.5621C13.4536 16.7694 12.9172 16.8761 12.3755 16.8761C11.8338 16.8761 11.2974 16.7694 10.7969 16.5621C10.2964 16.3548 9.84171 16.0509 9.45867 15.6679L7.86768 14.0769",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraFlip);
export default __webpack_public_path__ + "static/media/camera-flip.0aaa8f359b431882792ee6f0f03230c9.svg";
export { ForwardRef as ReactComponent };